// FreeHub shell locale catalogue — Русский.
//
// Значение ключа: строка либо объект plural-форм CLDR (`one`/`few`/`many`/`other`).
// Плейсхолдеры `{name}` должны совпадать в en.js и ru.js (проверяет locale gate).
// Набор ключей обязан совпадать с en.js; обязательный список — в scripts/check-locales.js.

export default Object.freeze({
  // --- login / owner bootstrap ---------------------------------------------
  "login.bootstrap.heading": "Создать владельца",
  "login.bootstrap.sub": "Управление документами и семантическим поиском",
  "login.bootstrap.note":
    "Создайте единственную учётную запись владельца. После этого войдите с выбранными данными.",
  "login.bootstrap.submit": "Создать владельца",
  "login.bootstrap.busy": "Создание...",
  "login.heading": "Вход",
  "login.sub": "Управление документами и семантическим поиском",
  "login.note": "Войдите с помощью имени пользователя и пароля.",
  "login.submit": "Войти",
  "login.busy": "Вход...",
  "login.username": "Имя пользователя",
  "login.password": "Пароль",
  "login.passwordConfirmation": "Подтверждение пароля",
  "login.version": "FreeHub community",
  "login.locale.label": "Язык интерфейса",

  // --- shell chrome --------------------------------------------------------
  "shell.nav.documents": "Документы",
  "shell.nav.agents": "Агенты",
  "shell.nav.evaluation": "Оценка качества",
  "shell.nav.logs": "Логи",
  "shell.nav.system": "System",
  "shell.nav.openMenu": "Открыть меню",
  "shell.nav.skipToMain": "Перейти к основному содержимому",
  "shell.ws.copy": "Копировать пространство имён",
  "shell.ws.copySuccess": "Скопировано: {name}",
  "shell.ws.copyError": "Не удалось скопировать",
  "shell.account.logoutTitle": "Выйти: {username}",
  "shell.action.newDocument": "Новый документ",
  "shell.action.newAgent": "Новый агент",
  "shell.locale.label": "Язык интерфейса",
  "shell.title.documents": "Документы",
  "shell.title.agents": "Агенты",
  "shell.title.evaluation": "Оценка качества",
  "shell.title.logs": "Логи",
  "shell.title.system": "System",
  "shell.subtitle.documents": "Загрузка, обработка и управление документами",
  "shell.subtitle.agents": "Связь агентов с наборами знаний.",
  "shell.subtitle.evaluation": "Качество поиска и ответов.",
  "shell.subtitle.logs": "Следы выполнения и события системы.",
  "shell.subtitle.system": "Сессии администратора и пароль владельца.",

  // --- System panel (Story 1.6) -------------------------------------------
  "system.sessions.title": "Завершение сеансов",
  "system.sessions.descriptionLead":
    "Кнопка аватара завершает только текущий сеанс. Действие ниже завершает ",
  "system.sessions.descriptionStrong": "все",
  "system.sessions.descriptionTail":
    " административные сеансы установки, включая этот.",
  "system.sessions.submit": "Завершить все сессии",
  "system.sessions.confirmQuestion":
    "Завершить все сеансы, включая этот? Для продолжения потребуется вход заново.",
  "system.sessions.busy": "Завершение…",
  "system.sessions.confirm": "Подтвердить",
  "system.sessions.cancel": "Отмена",
  "system.password.title": "Пароль владельца",
  "system.password.description":
    "Смена пароля сразу делает прежний пароль недействительным и завершает все " +
    "административные сеансы. Подтверждение нового пароля нужно только здесь и на сервер " +
    "не отправляется.",
  "system.password.open": "Сменить пароль",
  "system.password.current": "Текущий пароль",
  "system.password.new": "Новый пароль",
  "system.password.confirmation": "Подтвердите новый пароль",
  "system.password.submit": "Сменить пароль",
  "system.password.busy": "Смена…",
  "system.password.cancel": "Отмена",

  // --- shared notices ------------------------------------------------------
  "notice.sessionEnded":
    "Все сеансы завершены. Войдите заново — прежние сеансы больше не действуют.",
  "notice.passwordChanged": "Пароль изменён, все сеансы завершены. Войдите с новым паролем.",
  "notice.logoutUnconfirmed":
    "Не удалось подтвердить выход на сервере. Сессия могла остаться активной до истечения " +
    "срока — повторите выход.",
  "notice.sessionExpired":
    "Сессия администратора истекла. Войдите снова: выбранные файлы и незавершённые формы " +
    "потребуется задать заново.",
  "notice.bootstrapAlreadyComplete":
    "Настройка уже выполнена. Войдите с данными владельца.",
  "notice.bootstrapNotConfirmed":
    "Сервер не подтвердил завершение настройки. Повторите вход позже.",
  "notice.bootstrapOwnerCreated":
    "Владелец создан. Теперь войдите с выбранными данными.",
  // Story 1.8: fallback-навигация к списку вместо отсутствующего документа.
  "notice.documentMissing":
    "Этот документ больше не доступен: он был удалён или не найден. " +
    "Показан список документов.",
  // Story 1.8: недоступный список не выдаётся за удалённый документ.
  "error.route.documentsUnavailable":
    "Сервер FreeHub временно недоступен: список документов не загрузился. " +
    "Попробуйте позже.",
  // Story 1.14: create-вход закрыт, пока готовность системы не подтверждена.
  "notice.readinessUnavailable":
    "Проверка готовности системы не подтверждена, поэтому создание документа " +
    "недоступно. Посмотрите состояние служб и нажмите «Проверить снова».",
  "error.upload.notReady":
    "Загрузка недоступна: готовность обязательных служб не подтверждена. " +
    "Проверьте состояние системы и повторите попытку.",

  // --- login/bootstrap/session errors (safe semantic codes) ----------------
  "error.auth_unavailable": "Сервер FreeHub временно недоступен",
  "error.auth_invalid_response": "Сервер FreeHub вернул некорректный ответ",
  "error.auth_session_unavailable": "Не удалось проверить сессию",
  "error.auth_session_timeout": "Проверка сессии не ответила вовремя",
  "error.auth_bootstrap_check_failed": "Не удалось проверить состояние настройки",
  "error.auth_bootstrap_check_unavailable": "Не удалось подтвердить состояние настройки",
  "error.auth_bootstrap_unavailable":
    "Сервер FreeHub временно недоступен. Первоначальная настройка закрыта.",
  "error.auth_bootstrap_status_invalid":
    "Сервер FreeHub вернул некорректный статус первоначальной настройки",
  "error.auth_bootstrap_response_invalid": "Не удалось обработать ответ сервера",
  "error.auth_bootstrap_request_invalid":
    "Проверьте имя пользователя и пароль: сервер отклонил введённые данные.",
  "error.auth_owner_unavailable":
    "Сервер FreeHub временно недоступен. Владелец не создан, попробуйте позже.",
  "error.auth_owner_create_failed": "Не удалось создать владельца. Попробуйте позже.",
  "error.auth_invalid_credentials": "Неверное имя пользователя или пароль",
  "error.auth_rate_limited": "Слишком много неудачных попыток входа. Повторите позже.",
  "error.auth_session_create_failed": "Не удалось создать сессию",
  "error.auth_login_failed": "Не удалось войти",
  "error.auth_request_oversized": "Размер запроса превышает допустимый предел",

  // --- System command refusals (Story 1.6 semantics, semantic keys) --------
  "error.command.invalid_credentials":
    "Текущий пароль неверен. Исправьте значение и попробуйте снова.",
  "error.command.password_unchanged":
    "Новый пароль совпадает с текущим. Задайте другой пароль.",
  "error.command.password_policy_violation":
    "Новый пароль не соответствует требованиям: выберите более длинный и неочевидный.",
  "error.command.invalid_password_change_request":
    "Сервер отклонил запрос на смену пароля: проверьте заполненные поля.",
  "error.command.invalid_session_command_request":
    "Сервер не принимает параметры для этого действия. Повторите без данных.",
  "error.command.unsupported_media_type":
    "Сервер отклонил формат запроса. Обновите страницу и повторите.",
  "error.command.csrf_rejected":
    "Защита от межсайтовых запросов отклонила действие. Обновите страницу и повторите действие.",
  "error.command.auth_overload": "Сервер перегружен проверкой пароля. Подождите и повторите.",
  "error.command.unavailable": "Сервер FreeHub временно недоступен. Повторите действие.",
  "error.command.unknown_commit":
    "Сервер не подтвердил результат: изменение могло примениться или не примениться. " +
    "Войдите заново и проверьте состояние — повторять команду автоматически небезопасно.",
  "error.command.unconfirmed":
    "Сервер не подтвердил завершение действия: ответ не соответствует контракту, поэтому " +
    "изменение могло примениться или не примениться. Войдите заново и проверьте состояние — " +
    "повторять команду автоматически небезопасно.",
  "error.command.aborted":
    "Сервер не подтвердил результат: изменение могло примениться или не примениться. " +
    "Войдите заново и проверьте состояние — повторять команду автоматически небезопасно.",
  "error.command.authentication_required": "Сессия истекла — войдите заново.",
  "error.command.generic": "Не удалось выполнить действие. Повторите действие.",
  "error.password.mismatch": "Новые пароли не совпадают.",
  "error.bootstrap_password.mismatch": "Пароли не совпадают",
  "error.model.unavailable": "Не удалось получить состояние настроек. Повторите позже.",

  // --- Story 1.10: model settings и read-only storage diagnostics ---------
  "system.model.title": "Подключение модели",
  "system.model.description":
    "Проверьте Ollama-совместимую модель до сохранения. Сохранение не активирует RAG-профиль и не переиндексирует документы.",
  "system.model.provider": "Тип подключения",
  "system.model.local": "Локальная модель",
  "system.model.remote": "Удалённая модель",
  "system.model.baseUrl": "Базовый URL",
  "system.model.model": "Модель",
  "system.model.dimension": "Объявленная размерность",
  "system.model.credential": "Credential (только запись)",
  "system.model.credentialPresent": "Credential сохранён; значение не показывается.",
  "system.model.credentialAbsent": "Credential не задан.",
  "system.model.test": "Проверить подключение",
  "system.model.testing": "Проверка...",
  "system.model.save": "Сохранить настройки",
  "system.model.saving": "Сохранение...",
  "system.model.idle": "Проверка ещё не выполнялась.",
  "system.model.resultOk": "Подключение проверено: {model}, размерность {dimension}.",
  "system.model.resultFailed": "Проверка не удалась: {reason}.",
  "system.model.testRequired": "Сначала выполните успешную проверку подключения.",
  "system.model.saved": "Настройки сохранены. Активный RAG-профиль не изменён.",
  "system.model.storageHint": "Путь хранения модели задаётся в .env; storage endpoints здесь не редактируются.",
  "system.storage.title": "Диагностика хранилищ",
  "system.storage.description":
    "Только чтение: состояние настроенных зависимостей по readiness-контракту. Storage endpoints и перенос данных выполняются вне панели.",
  "system.storage.ready": "Все настроенные компоненты готовы.",
  "system.storage.notReady": "Есть недоступные компоненты.",
  "system.storage.unknown": "Состояние не получено.",
  "system.storage.status.ready": "готово",
  "system.storage.status.notReady": "не готово",
  "system.storage.component.postgres": "PostgreSQL",
  "system.storage.component.qdrant": "Qdrant",
  "system.storage.component.age": "Apache AGE (PostgreSQL)",
  "system.storage.component.memgraph": "Memgraph (прежнее внешнее хранилище)",
  "system.storage.component.graph": "Графовое хранилище",
  "system.storage.component.s3": "Объектное хранилище S3",
  "system.storage.reason.graph_backend_unsupported":
    "Настроенное графовое хранилище не поддерживается.",
  "system.storage.reason.graph_backend_incompatible":
    "Графовое хранилище установлено, но его версия или схема несовместимы.",
  "system.storage.reason.configuration_missing": "Не заданы обязательные настройки хранилища.",
  "system.storage.reason.authentication_failed":
    "Хранилище отклонило настроенные учётные данные.",
  "system.storage.reason.connection_failed": "Не удалось подключиться к хранилищу.",
  "system.storage.reason.dependency_error":
    "Проверка зависимости хранилища завершилась ошибкой.",
  "system.storage.reason.timeout": "Проверка хранилища не завершилась вовремя.",
  "system.storage.reason.unknown":
    "Проверка хранилища сообщила о неклассифицированной проблеме.",
  // --- Story 1.14: безопасные действия и состояние системы на landing ------
  "system.storage.action.check_configuration": "Проверьте настройки хранилища.",
  "system.storage.action.check_credentials": "Проверьте учётные данные хранилища.",
  "system.storage.action.check_connection": "Проверьте сетевое подключение к хранилищу.",
  "system.storage.action.check_component": "Проверьте работу самого компонента хранилища.",
  "system.storage.action.retry_check": "Повторите проверку позже.",
  "system.storage.action.unknown": "Повторите проверку и посмотрите журналы.",
  "overview.status.title": "Состояние системы",
  "overview.status.process.available": "Процесс API: доступен",
  "overview.status.process.unavailable": "Процесс API: недоступен",
  "overview.status.process.unknown": "Процесс API: состояние не подтверждено",
  "overview.status.dependencies.ready": "Обязательные службы готовы",
  "overview.status.dependencies.notReady": "Обязательные службы не готовы",
  "overview.status.dependencies.unknown": "Состояние служб не подтверждено",
  "overview.status.dependencies.stale": "Готовность служб устарела",
  "overview.status.stale": "Данные устарели — нажмите «Проверить снова».",
  "overview.status.refresh": "Проверить снова",
  "system.model.reason.invalid_base_url": "недопустимый URL — нужен http/https origin без параметров",
  "system.model.reason.invalid_model": "недопустимое имя модели",
  "system.model.reason.invalid_dimension": "размерность должна быть от 1 до 65536",
  "system.model.reason.invalid_credential": "недопустимое значение credential",
  "system.model.reason.timeout": "истекло время ожидания",
  "system.model.reason.unsupported_model": "сервис не поддерживает эту модель",
  "system.model.reason.connection_failed": "не удалось подключиться к сервису",
  "system.model.reason.dependency_error": "сервис вернул ошибку",
  "system.model.reason.response_too_large": "ответ сервиса слишком большой",
  "system.model.reason.invalid_response": "некорректный ответ сервиса",
  "system.model.reason.count_mismatch": "сервис вернул неверное число векторов",
  "system.model.reason.dimension_mismatch": "фактическая размерность не совпала с объявленной",
  "system.model.reason.non_finite": "вектор содержит нечисловые значения",
  "system.model.reason.zero_vector": "вектор состоит из нулей",
  "system.model.reason.model_mismatch": "сервис ответил другой моделью, а не объявленной",
  "system.model.reason.successful_connection_test_required": "сначала выполните успешную проверку подключения",
  "system.model.reason.draft_changed_after_test": "настройки изменились после проверки — проверьте снова",
  "system.model.reason.revision_mismatch": "настройки уже изменены — загрузите актуальное состояние",
  "system.model.reason.probe_revision_mismatch": "проверка относится к прежней версии настроек",
  "system.model.reason.model_settings_storage_unavailable": "хранилище настроек недоступно",
  "system.model.reason.model_probe_concurrency_exhausted": "слишком много одновременных проверок",
  "system.model.reason.request_too_large": "запрос слишком большой",
  "system.model.reason.invalid_request_body": "некорректный запрос",
  "system.model.reason.authentication_required": "сессия истекла — войдите заново",
  "system.model.reason.unknown": "неизвестная причина",

  // --- shell formatting ----------------------------------------------------
  "format.bytes.empty": "0 Б",
  "format.bytes.unit.b": "Б",
  "format.bytes.unit.kb": "КБ",
  "format.bytes.unit.mb": "МБ",
  "format.date.none": "без даты",
});
